module.exports = __webpack_public_path__ + "static/img/zhiye.d45af425.png";